// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content_Content__237l9","Spacer":"Content_Spacer__hy8hb"};